import { createContext } from "react";
import { DialogComponent } from "./types";

export interface DialogsContextValue {
  open: OpenDialog;
  close: <R>(dialog: Promise<R>, result: R) => Promise<R>;
}

export const DialogsContext = createContext<DialogsContextValue | null>(null);

export interface OpenDialogOptions<R> {
  onClose?: (result: R) => Promise<void>;
}

export interface OpenDialog {
  <P extends undefined, R>(
    Component: DialogComponent<P, R>,
    payload?: P,
    options?: OpenDialogOptions<R>,
  ): Promise<R>;

  <P, R>(
    Component: DialogComponent<P, R>,
    payload: P,
    options?: OpenDialogOptions<R>,
  ): Promise<R>;
}

export interface CloseDialog {
  <R>(dialog: Promise<R>, result: R): Promise<R>;
}
